import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const CheckoutApi = createAsyncThunk(
  "checkout/Checkout",
  async (billingAddress, thunkAPI) => {
    try {
      const billingAddressData = {
        firstName: billingAddress?.firstName,
        lastName: billingAddress?.lastName,
        email: billingAddress?.email,
        streetAddress: billingAddress?.streetAddress,
        city: billingAddress?.city,
        state: billingAddress?.state,
        pinCode: billingAddress?.pinCode,
        phone: billingAddress?.phone,
      };
      let storedUuid = localStorage.getItem("uuid");
      const Token = localStorage.getItem("authToken");
      const response = await axios.post(
        endPoint.PLACEORDER,
        {
          paymentMethod: billingAddress?.paymentMethod,
          billingAddress: billingAddressData,
          sessionId: storedUuid ? storedUuid : "",
        },
        {
          headers: {
            Authorization: Token ? `Bearer ${Token}` : "",
          },
        }
      );
   
      return response.data;
    } catch (error) {
    
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const CheckoutSlice = createSlice({
  name: "CheckoutData",
  initialState: {
    CheckoutData: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(CheckoutApi.fulfilled, (state, action) => {
        state.CheckoutData = action.payload; 
      })
      .addCase(CheckoutApi.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default CheckoutSlice.reducer;
